import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment/moment';

@Pipe({ name: 'UtcToLocaltimePipe' })
export class UtcToLocaltimePipe implements PipeTransform {
  transform(value: any, format: string = 'MMMM D, YYYY hh:mm a') {
    if (value) {
      return moment.utc(value).local().format(format);
    }
    return value;
  }
}
